// src/pages/Swaps/EditSwapListing.jsx

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../config";


function EditSwapListing() {
    console.log("🔥 EDIT SWAP PAGE MOUNTED");

  const { id } = useParams();   // DB id
const navigate = useNavigate();


  // ===== STATE (IDENTICAL TO POST FORM) =====
  const [swap_from_suburb, setSwapFromSuburb] = useState("");
  const [swap_from_postcode, setSwapFromPostcode] = useState("");

  const [swap_to_suburb, setSwapToSuburb] = useState("");
  const [swap_to_postcode, setSwapToPostcode] = useState("");
  const [swap_to_state, setSwapToState] = useState("");

  const [accessType] = useState("Access Available Anytime");
  const [streetParking, setStreetParking] = useState(false);
  const [schoolZone, setSchoolZone] = useState(false);
  const [hasDogs, setHasDogs] = useState(false);
  const [greenBin, setGreenBin] = useState(false);

  const [serviceDay, setServiceDay] = useState("any");
  const [serviceTime, setServiceTime] = useState("any");

  const [time, setTime] = useState("");
  const [frequency, setFrequency] = useState("fortnightly");
  const [rideOnOrPush, setRideOnOrPush] = useState("Push");
  const [bagMulch, setBagMulch] = useState("Mulch");

  const [frontLawn, setFrontLawn] = useState(false);
  const [rearLawn, setRearLawn] = useState(false);
  const [natureStrip, setNatureStrip] = useState(false);
  const [acreage, setAcreage] = useState(false);

  const [cutValue, setCutValue] = useState("");

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);



  // ===== LOAD EXISTING LISTING =====
useEffect(() => {
  async function loadListing() {
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(
        `${API_BASE_URL}/api/swap-listings/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error();

      const s = data.listing ?? data;


      setSwapFromSuburb(s.swap_from_suburb || "");
      setSwapFromPostcode(s.swap_from_postcode || "");

      setSwapToSuburb(s.swap_to_suburb || "");
      setSwapToPostcode(s.swap_to_postcode || "");
      setSwapToState(s.swap_to_state || "");

      setStreetParking(s.streetParking === 1);
      setSchoolZone(s.schoolZone === 1);
      setHasDogs(s.hasDogs === 1);
      setGreenBin(s.greenBin === 1);

      setServiceDay(s.serviceDay || "any");
      setServiceTime(s.serviceTime || "any");

      setTime(String(s.time || ""));
      setFrequency(s.frequency || "fortnightly");
      setRideOnOrPush(s.rideOnOrPush || "Push");
      setBagMulch(s.bagMulch || "Mulch");

      setFrontLawn(s.frontLawn === 1);
      setRearLawn(s.rearLawn === 1);
      setNatureStrip(s.natureStrip === 1);
      setAcreage(s.acreage === 1);

      setCutValue(s.cutValue || "");
    } catch (err) {
      console.error(err);
      setMessage("❌ Failed to load swap listing.");
    } finally {
      setLoading(false);
    }
  }

  loadListing();
}, [id]);


  // ===== SUBMIT =====
 const handleSubmit = async (e) => {
  e.preventDefault();
  setMessage("");

  try {
    const token = localStorage.getItem("token");

    // ✅ DEFINE FIRST
    const payload = {
      swap_from_suburb,
      swap_from_postcode,
      swap_to_suburb,
      swap_to_postcode,
      swap_to_state,

      accessType,

      streetParking: streetParking ? 1 : 0,
      schoolZone: schoolZone ? 1 : 0,
      hasDogs: hasDogs ? 1 : 0,
      greenBin: greenBin ? 1 : 0,

      serviceDay,
      serviceTime,

      time,
      frequency,
      rideOnOrPush,
      bagMulch,

      frontLawn: frontLawn ? 1 : 0,
      rearLawn: rearLawn ? 1 : 0,
      natureStrip: natureStrip ? 1 : 0,
      acreage: acreage ? 1 : 0,

      cutValue: Number(cutValue),
    };

    // ✅ LOG AFTER DECLARATION
    console.log("PUT PAYLOAD:", payload);

    const res = await fetch(
      `${API_BASE_URL}/api/swap-listings/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();
    console.log("PUT RESPONSE:", data);

    if (!res.ok) {
      setMessage(`❌ ${data.error || "Failed to save changes"}`);
      return;
    }

    setMessage("✅ Swap listing updated successfully!");
    setTimeout(() => navigate("/dashboard"), 1200);
  } catch (err) {
    console.error(err);
    setMessage("❌ Failed to save changes.");
  }
};


  if (loading) return <p style={{ textAlign: "center" }}>Loading…</p>;

  // ===== UI (IDENTICAL TO POST FORM) =====
  return (
    <div style={containerStyle}>
      <h2 style={headerTitle}>Edit Swap Listing</h2>

      {message && (
        <div
          style={{
            marginBottom: "20px",
            textAlign: "center",
            color: message.includes("❌") ? "#d32f2f" : "#2e7d32",
            fontWeight: 600,
          }}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} style={formStyle}>
        {/* ===== SWAP LOCATION ===== */}
        <h3 style={sectionHeader}>Swap Location</h3>

        <label style={boldLabel}>Swap From Suburb:</label>
        <input value={swap_from_suburb} onChange={(e)=>setSwapFromSuburb(e.target.value)} required style={inputStyle} />

        <label style={boldLabel}>Swap From Postcode:</label>
        <input value={swap_from_postcode} onChange={(e)=>setSwapFromPostcode(e.target.value)} required style={inputStyle} />

        <label style={boldLabel}>Swap To Suburb:</label>
        <input value={swap_to_suburb} onChange={(e)=>setSwapToSuburb(e.target.value)} required style={inputStyle} />

        <label style={boldLabel}>Swap To Postcode:</label>
        <input value={swap_to_postcode} onChange={(e)=>setSwapToPostcode(e.target.value)} required style={inputStyle} />

        <label style={boldLabel}>State:</label>
        <select value={swap_to_state} onChange={(e)=>setSwapToState(e.target.value)} required style={selectStyle}>
          <option value="">Select State</option>
          {["VIC","NSW","QLD","SA","WA","TAS","NT","ACT"].map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>

        {/* ===== ACCESS & PARKING ===== */}
        <h3 style={sectionHeaderBlue}>Access & Parking</h3>

        <label style={labelStyle}><input type="checkbox" checked={streetParking} onChange={(e)=>setStreetParking(e.target.checked)} /> Street Parking Available</label>
        <label style={labelStyle}><input type="checkbox" checked={schoolZone} onChange={(e)=>setSchoolZone(e.target.checked)} /> Located in a School Zone</label>
        <label style={labelStyle}><input type="checkbox" checked={hasDogs} onChange={(e)=>setHasDogs(e.target.checked)} /> Dogs on Property</label>
        <label style={labelStyle}><input type="checkbox" checked={greenBin} onChange={(e)=>setGreenBin(e.target.checked)} /> Green Bin Available</label>

        {/* ===== JOB DETAILS ===== */}
        <h3 style={sectionHeader}>Job Details</h3>

        <label style={boldLabel}>Preferred Day:</label>
        <select value={serviceDay} onChange={(e)=>setServiceDay(e.target.value)} style={selectStyle}>
          <option value="any">Any Day</option>
          <option value="monday">Monday</option>
          <option value="tuesday">Tuesday</option>
          <option value="wednesday">Wednesday</option>
          <option value="thursday">Thursday</option>
          <option value="friday">Friday</option>
         <option value="saturday">Saturday</option>
          <option value="sunday">Sunday</option>
        </select>

        <label style={boldLabel}>Preferred Time:</label>
        <select value={serviceTime} onChange={(e)=>setServiceTime(e.target.value)} style={selectStyle}>
          <option value="any">Any reasonable time</option>
          <option value="am">Morning (AM)</option>
          <option value="pm">Afternoon (PM)</option>
        </select>

        <label style={boldLabel}>Estimated Time:</label>
        <select value={time} onChange={(e)=>setTime(e.target.value)} required style={selectStyle}>
          <option value="">Select Duration</option>
          <option value="0.5">30 Minutes</option>
          <option value="1">1 Hour</option>
          <option value="1.5">1 Hour 30 Minutes</option>
          <option value="2">2 Hours</option>
          <option value="3">3 Hours</option>
        </select>

        <label style={boldLabel}>Frequency:</label>
        <select value={frequency} onChange={(e)=>setFrequency(e.target.value)} style={selectStyle}>
          <option value="weekly">Weekly</option>
          <option value="fortnightly">Fortnightly</option>
          <option value="3weeks">Every 3 Weeks</option>
          <option value="monthly">Monthly</option>
        </select>

        <label style={boldLabel}>Mower Type:</label>
        <select value={rideOnOrPush} onChange={(e)=>setRideOnOrPush(e.target.value)} style={selectStyle}>
          <option value="Push">Push</option>
          <option value="Ride-on">Ride-on</option>
        </select>

        <label style={boldLabel}>Grass Handling:</label>
        <select value={bagMulch} onChange={(e)=>setBagMulch(e.target.value)} style={selectStyle}>
          <option value="Mulch">Mulch</option>
          <option value="Bag">Bag</option>
        </select>

        {/* ===== AREAS ===== */}
        <h3 style={sectionHeader}>Areas Serviced</h3>

        <label style={labelStyle}><input type="checkbox" checked={frontLawn} onChange={(e)=>setFrontLawn(e.target.checked)} /> Front Lawn</label>
        <label style={labelStyle}><input type="checkbox" checked={rearLawn} onChange={(e)=>setRearLawn(e.target.checked)} /> Rear Lawn</label>
        <label style={labelStyle}><input type="checkbox" checked={natureStrip} onChange={(e)=>setNatureStrip(e.target.checked)} /> Nature Strip</label>
        <label style={labelStyle}><input type="checkbox" checked={acreage} onChange={(e)=>setAcreage(e.target.checked)} /> Acreage Property</label>
        {/* ===== CUT VALUE ===== */}
        <h3 style={sectionHeaderOrange}>Cut Value</h3>
        <input type="number" value={cutValue} onChange={(e)=>setCutValue(e.target.value)} required style={inputStyle} />

        <button type="submit" style={buttonStyle}>Save Changes</button>
      </form>
    </div>
  );
}

// ===== STYLES (IDENTICAL) =====
const containerStyle = {
  maxWidth: "95%",
  width: "600px",
  margin: "50px auto",
  padding: "25px",
  backgroundColor: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
};

const headerTitle = { textAlign: "center", marginBottom: "25px", color: "#2e7d32" };
const formStyle = { display: "flex", flexDirection: "column", gap: "18px" };
const inputStyle = { padding: "10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: "1rem" };
const selectStyle = { ...inputStyle };
const labelStyle = { display: "flex", alignItems: "center", gap: "10px", fontSize: "0.95rem" };
const boldLabel = { fontWeight: "bold" };
const sectionHeader = { borderBottom: "2px solid #4caf50", paddingBottom: "5px" };
const sectionHeaderBlue = { borderBottom: "2px solid #0288d1", paddingBottom: "5px" };
const sectionHeaderOrange = { borderBottom: "2px solid #ff9800", paddingBottom: "5px" };
const buttonStyle = { padding: "16px", backgroundColor: "#4caf50", color: "#fff", border: "none", borderRadius: "8px", fontWeight: "bold", cursor: "pointer" };

export default EditSwapListing;
